'use client';
import { NewsCardMeta } from '@/lib/types';
import React, { createContext, useState, useContext } from 'react';

// Context for selectedVideoCard
const VideoCardContext = createContext<NewsCardMeta | null>(null);

// Context for setSelectedVideoCard function
const SetVideoCardContext = createContext<((videoCard: NewsCardMeta | null) => void) | undefined>(undefined);

export const FeedProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedVideoCard, setSelectedVideoCard] = useState<NewsCardMeta | null>(null);

  return (
    <VideoCardContext value={selectedVideoCard}>
      <SetVideoCardContext value={setSelectedVideoCard}>
        {children}
      </SetVideoCardContext>
    </VideoCardContext>
  )
};

export const useSelectedVideoCard = (): NewsCardMeta | null => {
  const context = useContext(VideoCardContext);
  if (context === null) {
    console.log('No selected video card found in context');
    
    return null
  }
  return context;
};

export const useSetSelectedVideoCard = (): ((videoCard: NewsCardMeta | null) => void) => {
  const context = useContext(SetVideoCardContext);
  if (!context) {
    throw new Error('No selected video card found in context');
  }
  return context;
};